/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash eca1aa216f158975a7d335c2a9343e9d */

import { ConcreteRequest } from "relay-runtime";

export type verifyEmailHandlerQueryVariables = {
    email?: string | null | undefined;
    buyerId?: string | null | undefined;
    hasBuyerId: boolean;
};
export type verifyEmailHandlerQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly profile: {
                readonly email: string | null;
            } | null;
            readonly authMetadata: {
                readonly emailOnly: boolean | null;
                readonly hasPassword: boolean | null;
            } | null;
        } | null | undefined;
        readonly userExistsMetadata: {
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
            readonly isGuest: boolean | null;
        } | null;
    };
};
export type verifyEmailHandlerQuery = {
    readonly response: verifyEmailHandlerQueryResponse;
    readonly variables: verifyEmailHandlerQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "buyerId"
    } as any, v1 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "email"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasBuyerId"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailOnly",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPassword",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGuest",
        "storageKey": null
    } as any, v7 = [
        {
            "kind": "Variable",
            "name": "userId",
            "variableName": "buyerId"
        } as any
    ], v8 = {
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "verifyEmailHandlerQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v3 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "kind": "LinkedField",
                            "name": "userExistsMetadata",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "condition": "hasBuyerId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UserExistsMetadataType",
                                            "kind": "LinkedField",
                                            "name": "authMetadata",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "verifyEmailHandlerQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v3 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "kind": "LinkedField",
                            "name": "userExistsMetadata",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v9 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v9 /*: any*/),
                        {
                            "condition": "hasBuyerId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UserExistsMetadataType",
                                            "kind": "LinkedField",
                                            "name": "authMetadata",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/verifyEmailHandlerQuery",
            "metadata": {},
            "name": "verifyEmailHandlerQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '929e148997e32bb6b42f33980d349e38';
export default node;
